import { render, staticRenderFns } from "./FilterVcDemo.vue?vue&type=template&id=10a3e024&scoped=true&"
import script from "./FilterVcDemo.vue?vue&type=script&lang=js&"
export * from "./FilterVcDemo.vue?vue&type=script&lang=js&"
import style0 from "./FilterVcDemo.vue?vue&type=style&index=0&id=10a3e024&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a3e024",
  null
  
)

export default component.exports